module.exports = __webpack_public_path__ + "static/contact-ace0bfe5116f982c15305928949a7ca0.jpg";